import { put, takeLatest, select } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../utils/request';
import moment from 'moment';

const getCurrentCenterId = state => state.identity.centerId;

function * getEvents (payload) {
  try {
    const { start, end } = payload;
    const centerId = yield select(getCurrentCenterId);
    const thisYear = moment().year();
    const startDate = moment(start).format('YYYY-MM-DD');
    const endDate = moment(end).format('YYYY-MM-DD');
    const monthYearKey = moment(start).format('YYYY-MM');

    // make request
    const response = yield ktRequest.get(`events?centerId=${centerId}&start=${startDate}&end=${endDate}`, 'events');
    const { all, birthdays, events } = response;

    // react-big-calendar expects certains keys for an event
    const rbcFormattedEvents = events.map(event => ({
      title: event.title,
      start: moment(event.starts_at).toDate(),
      end: event.ends_at ? moment(event.ends_at).toDate() : moment(event.starts_at).hours(17).minutes(0).seconds(0).milliseconds(0).toDate(), // default end time to 5pm?
      allDay: event.allDay,
      ...event
    }));
    const rbcFormattedBirthdays = birthdays.map(birthdayObject => {
      const { birthday, first_name: firstName, last_name: lastName } = birthdayObject;
      const correctedDate = moment(birthday).add(1, 'day').format('YYYY-MM-DD');

      return ({
        title: `${firstName} ${lastName}'s Birthday`,
        allDay: true,
        start: moment(correctedDate).clone().year(thisYear).toDate(),
        end: moment(correctedDate).clone().year(thisYear).toDate(),
        type: 'birthday',
        ...birthdayObject
      });
    });

    yield put(actions.getEventsSuccess(
      all,
      rbcFormattedEvents,
      rbcFormattedBirthdays,
      monthYearKey
    ));
  } catch (error) {
    yield put(actions.getEventsFailure(error));
  }
}

function * createOrUpdateEvent (payload) {
  try {
    const { id, title, location, date, startTime, endTime, description, allDay } = payload;
    const updatingExistingEvent = Boolean(id);
    const centerId = yield select(getCurrentCenterId);
    const body = { id, title, location, date, startTime, endTime, description, allDay, centerId };
    const response = yield ktRequest.post(`events/create`, body, 'events');

    if (!response.ok) {
      const json = yield response.json();
      throw new Error(json.error);
    }

    let { data } = yield response.json();
    // add `start` and `end` keys for react-big-calendar
    data['start'] = moment(data.starts_at).toDate();
    data['end'] = data.ends_at ? moment(data.ends_at).toDate() : moment(data.starts_at).hours(17).minutes(0).seconds(0).milliseconds(0).toDate();

    yield put(actions.saveEventSuccess(data, updatingExistingEvent));
  } catch (error) {
    yield put(actions.saveEventFailure(error));
  }
}

export const eventSagas = [
  takeLatest(types.GET_EVENTS_REQUEST, getEvents),
  takeLatest(types.SAVE_EVENT_REQUEST, createOrUpdateEvent)
];
